export const cartMessages = {
  'cart.checkout': '去结算 →',
  'cart.continue': '继续购物 →',
  'cart.empty': '购物车还是空的',
  'cart.goShop': '去挑选商品 →',
  'cart.items': '件商品',
  'cart.qty': '数量',
  'cart.sub': '共',
  'cart.subtotal': '小计',
  'cart.title': '我的购物车',
  'cart.total': '合计',
  'cart.totalItems': '件商品',
  'cart.unitPrice': '单价',
  'checkout.addressTitle': '收货地址',
  'checkout.backCart': '返回购物车',
  'checkout.emptyCart': '购物车为空',
  'checkout.freeShipping': '免运费',
  'checkout.goAddAddress': '去添加地址',
  'checkout.goodsTitle': '商品清单',
  'checkout.goodsTotal': '商品总额',
  'checkout.manageAddress': '管理地址',
  'checkout.noAddress': '请选择收货地址',
  'checkout.noAddressHint': '暂无收货地址，请先添加',
  'checkout.payable': '实付金额',
  'checkout.shippingFee': '运费',
  'checkout.submit': '提交订单',
  'checkout.submitFail': '下单失败',
  'checkout.submitting': '提交中',
  'checkout.title': '确认订单',
  'orderSuccess.amount': '订单金额',
  'orderSuccess.continue': '继续购物',
  'orderSuccess.desc': '感谢您的购买，我们将尽快为您发货',
  'orderSuccess.orderNo': '订单号',
  'orderSuccess.title': '下单成功',
  'orderSuccess.viewOrder': '查看订单',
};
